export default __webpack_public_path__ + "static/media/Screenshot (1081).f50b3818.png";